import { useQuery } from '@tanstack/react-query';
import { LocationDtoV3 } from '../../generated-api';

export enum CashDrawerStatus {
  NOT_FOUND = 'not found', // There is no cash register found for the location selected in the app
  CONNECTED = 'connected', // The app has a connection to a cash register
  DISCONNECTED = 'disconnected', // There is a cash register for the location, however it is currently not connected to the app
  ERROR = 'error', // There is a cash register for the location, however it is in an error state.
}

export const useCashStatus = () => {
  const cashStatusQuery = useQuery({
    queryKey: ['cashDrawerState'],

    queryFn: () => {
      const status = localStorage.getItem('cash_drawer_state');

      return (status ?? CashDrawerStatus.NOT_FOUND) as CashDrawerStatus;
    },
  });

  return cashStatusQuery;
};

export const useShouldDisplayCashButton = (location: LocationDtoV3): boolean => {
  const { data: cashStatus, isSuccess } = useCashStatus();

  const isUk = location.countryCode === 'UK';
  const cashDrawerMissing = cashStatus === CashDrawerStatus.NOT_FOUND;

  if (isUk || cashDrawerMissing) {
    return false;
  }

  return isSuccess;
};
